import './App.css'

import React from 'react'
import Routers from './routes/Routers'
import LayoutMain from './layout/LayoutMain'
import Rain from './components/rain'

export default function App() {
  return (
    <>
      <LayoutMain>
        <Rain />
        <Routers />
      </LayoutMain>
    </>
  )
}
